/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {TableEl} from 'common/components/table';
import {propagateEvent} from 'common/util/dom';

import type {UsersTable} from './index';

export function template(this: UsersTable) {
  const {rows} = this.state;

  return (
    <div sel='.users-table' style={{height: `100%`}}>
      <TableEl
        attrs={this.helpers.getTableAttrs()}
        props={{
          rows,
          columns: this.helpers.getTableColumns(),
        }}
        on={{
          selectionChange: this.helpers.handleTableSelectionChanged,
          rowClick: this.helpers.handleTableRowClicked,
          sortChange: this.helpers.handleTableSortChanged,
          columnMoved: this.helpers.handleColumnMoved,
          columnResize: (ev) => propagateEvent(this, ev),
          cellClick: this.helpers.handleCellClick,
        }}
      />
    </div>
  );
}
